import React from 'react';
import { Card } from "@material-ui/core";
import { RECO_TYPE } from '../../../../constants/common';

export default function RecommendationsProgramsItems(props) {
    return (
        <div>
            <Card className="recommedations-item" onMouseOver={() => props.onHoverRecos(props.item.recommendationsMetaData.recommendationId, RECO_TYPE.PROGRAM)}>
                <div className="image-container">
                    <img src={props.item.recommendationsMetaData.dashboardIcon} alt={props.item.recommendationsMetaData.title} />
                </div>
                <div className="content-container">
                    <div className="content">
                        <p className="title">{props.item.recommendationsMetaData.title}</p>
                        <p className="description">{props.item.recommendationsMetaData.description}</p>
                        {props.item.recommendationsMetaData.link && props.item.recommendationsMetaData.callToAction && (
                            <div className="cta" onClick={()=>props.learnMoreClickHandler(props.item.recommendationsMetaData.recommendationId, props.item.recommendationsMetaData.link)}>{props.item.recommendationsMetaData.callToAction}</div>
                        )}
                    </div>
                    {
                        props.item.insight && !!props.item.insight.insightText && props.recoInsightsEnabled &&
                        <div className="reco-insight-container">
                            <img src={props.insightBulbImage} alt=""/>
                            <div className="insight">
                                {props.item.insight.insightText}
                            </div>
                        </div>
                    }
                </div>                   
            </Card>
        </div>
    )
}